<template>
    <div class="f-address-detail narrow-container">
        <div class="f-subsection f-subsection-custom">
            <router-link to="/staking">
                <div class="arrow">
                    <svg
                        width="26"
                        height="15"
                        viewBox="0 0 26 15"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M25.5 7.5H1M1 7.5L8 1M1 7.5L8 14"
                            :stroke="darkMode ? '#fff' : '#000'"
                        />
                    </svg>
                </div>
            </router-link>

            <h1>Delegate VC</h1>
            <div class="conect-block">
                <div
                    v-if="!address"
                    :class="
                        darkMode
                            ? 'btn-connect btn large primary'
                            : 'btn-connect-dark btn large primary'
                    "
                    @click="showWalletDialog = true"
                >
                    Connect Wallet
                </div>
                <div
                    v-else
                    :class="
                        darkMode
                            ? 'btn-connect btn large primary'
                            : 'btn-connect-dark btn large primary'
                    "
                    @click="disconnect()"
                >
                    <p>
                        {{ shortAddress }}
                    </p>
                </div>
            </div>
        </div>
        <div class="f-card">
            <div class="form">
                <div class="inp-amount">
                    <div>
                        <span>Amount</span>
                        <span class="validator"
                            >validator id - {{ selectValidator }}</span
                        >
                    </div>
                    <FInput
                        placeholder="Stake amount"
                        v-model="amount"
                        class="inp-amount"
                        fieldSize="large"
                        validateOnInput
                        :validator="validator"
                        :errorMessage="errorMessage"
                        type="number"
                    >
                    </FInput>
                    <!-- <input
                        type="text"
                        name="amount"
                        placeholder="Delegate amount"
                        v-model="amount"
                        class="inp large"
                        @focus="onFocus"
                        @blur="onBlur"
                    /> -->
                </div>
                <div class="inp-validator">
                    <div>
                        <span>Validator</span>
                    </div>
                    <!-- <FInput></FInput> -->
                    <select
                        name="validator"
                        class="inp large"
                        @focus="onFocus"
                        @blur="onBlur"
                        v-model="selectValidator"
                    >
                        <option
                            v-for="validator in validatorsIDs"
                            :key="validator"
                            :value="validator"
                            >{{ validator }}</option
                        >
                    </select>
                </div>
                <button
                    class="btn large primary btn-continue"
                    @click="showStakeDialog = true"
                    :disabled="isDisabled"
                >
                    Continue
                </button>
            </div>
        </div>
        <h2 class="h1">
            {{ $t("view_validator_list.validators") }}
            <span v-if="dRecordsCount" class="f-records-count"
                >({{ dRecordsCount }})</span
            >
        </h2>
        <f-validator-list
            class="validators-vc"
            code="validators"
            @records-count="onRecordsCount"
        >
            <!-- @validator-list-totals="onValidatorListTotals"
            @validator-list-offline="onValidatorListOffline"
            @validator-list-flagged="onValidatorListFlagged"
            @validator-list-inactive="onValidatorListInactive" -->
        </f-validator-list>
        <ConnectDialog
            v-if="showWalletDialog"
            @close="showWalletDialog = false"
        />
        <StakeDialog
            v-if="showStakeDialog"
            :amount="amount"
            :loading="getDialogLoading"
            :errorMsg="getErrorMsg"
            @close="closeStakeDialog"
            @action="stake"
        />
        <SuccessAlert
            v-if="showSuccessAlert"
            :successMsg="getSuccessMsg"
            @close="closeSuccess"
        />
        <ErrorAlert
            v-if="showErrorAlert"
            :errorMsg="getErrorMsg"
            @close="closeError"
        />
    </div>
</template>

<script>
import FInput from "../components/core/FInput/FInput.vue";
import ConnectDialog from "../components/dialogs/ConnectDialog.vue";
import StakeDialog from "../components/dialogs/StakeDialog.vue";
import FValidatorList from "../data-tables/FValidatorListForSelect.vue";
import SuccessAlert from "../components/dialogs/SuccessAlert.vue";
import ErrorAlert from "../components/dialogs/ErrorAlert.vue";

import { mapState, mapActions, mapGetters, mapMutations } from "vuex";
import { toBigNumberFloat } from "@/utils/big-number.js";
import { BigNumber } from "ethers";

export default {
    name: "DelegateVC",
    components: {
        ConnectDialog,
        StakeDialog,
        FInput,
        FValidatorList,
        SuccessAlert,
        ErrorAlert
    },
    data() {
        return {
            amount: "",
            selectValidator: 0,
            showWalletDialog: false,
            showStakeDialog: false,
            showSuccessAlert: false,
            showErrorAlert: false,
            dRecordsCount: 0
        };
    },
    watch: {
        getSuccessMsg(value) {
            if (value) {
                this.showStakeDialog = false;
                this.showSuccessAlert = true;
            }
        },
        getErrorMsg(value) {
            if (value) {
                this.showStakeDialog = false;
                this.showErrorAlert = true;
            }
        }
    },
    methods: {
        ...mapActions([
            "connectMetamask",
            "updateProviderState",
            // "isLoggedIn",
            "disconnect",
            "delegate"
        ]),
        ...mapMutations(["setErrorMsg", "setSuccessMsg"]),
        onFocus() {},
        onBlur() {},
        closeSuccess() {
            this.setSuccessMsg("");
            this.showSuccessAlert = false;
        },
        closeError() {
            this.setErrorMsg("");
            this.showErrorAlert = false;
        },
        stake() {
            this.delegate({
                delegate: this.amount,
                toValidatorID: this.selectValidator
            });
            this.amount = "";
            this.selectValidator = this.validatorsIDs[0];
            this.updateProviderState();
        },
        closeStakeDialog() {
            this.setErrorMsg("");
            this.setSuccessMsg("");
            this.showStakeDialog = false;
        },
        validator(value) {
            if (isNaN(Number(value))) return false;
            else {
                if (!value) return true;
                else {
                    const amount = BigNumber.from(
                        toBigNumberFloat(value.trim())
                    );
                    return amount.lte(0) || amount.gt(this.balance)
                        ? false
                        : true;
                }
            }
        },
        /**
         * @param {int} _num
         */
        onRecordsCount(_num) {
            this.dRecordsCount = _num;
        }
    },
    computed: {
        ...mapGetters([
            "balance",
            "validatorsIDs",
            "shortAddress",
            "getDialogLoading",
            "getErrorMsg",
            "getSuccessMsg"
        ]),
        ...mapState({
            address: state => state.address,
            darkMode: state => state.darkMode
        }),
        isDisabled() {
            return (
                !this.amount ||
                !this.selectValidator ||
                !this.address ||
                Boolean(this.errorMessage)
            );
        },
        errorMessage() {
            if (!this.amount) return "";
            else if (isNaN(Number(this.amount)))
                return "Amount must be a number";
            if (!isNaN(Number(this.amount))) {
                const amount = BigNumber.from(
                    toBigNumberFloat(this.amount.trim())
                );
                if (amount.lte(0)) return "Amount must be more than zero";
                else if (amount.gt(this.balance))
                    return "Delegate amount exceeds balance";
                else return "";
            } else return "";
        }
    },
    mounted() {
        if (this.validatorsIDs[0]) {
            this.selectValidator = this.validatorsIDs[0];
        }
    }
};
</script>

<style lang="scss">
.form {
    display: flex;
    flex-direction: column;
    width: 80%;
    margin: 0 auto;
    margin-top: 40px;
    align-items: center;
    .inp-amount,
    .inp-validator {
        margin-bottom: 24px;
        width: 100%;
        div {
            display: flex;
            justify-content: space-between;
            margin-bottom: 12px;
        }
        input {
            height: 44px;
            width: 100%;
        }
        select {
            width: 100%;
        }
        .validator {
            color: #3478f6;
        }
    }
}

.f-address-detail {
    .balance {
        height: calc(100% - 48px);
        text-align: end;

        h3 {
            text-align: end;
            margin-bottom: 0;
        }

        .usd {
            color: $light-gray-color;
            font-size: 26px;
        }
    }

    .num-block {
        h2 {
            text-align: center;
            margin-top: 16px;
            margin-bottom: 4px;
        }

        .num {
            text-align: center;
            font-weight: bold;
            font-size: $fs36;
        }
    }

    .f-tabs {
        h2 {
            font-size: 18px;
        }
    }
}

.f-card {
    border-radius: 8px !important;
}

.f-subsection-custom {
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
    margin-bottom: 24px;
    .arrow {
        width: 200px;
    }
    h1 {
        font-weight: 400;
        font-size: 42px;
        text-align: center;
        margin: 0;
    }
}

.validators-vc {
    margin-top: 27px;
}

.h1 {
    margin-top: 53px;
}

.btn-connect {
    transition: 200ms;
    width: 252px;
    height: 55px;
}

.btn-connect-dark {
    transition: 200ms;
    width: 252px;
    height: 55px;
    color: #fff !important;
}

.btn-continue {
    transition: 200ms;
    width: 220px;
    height: 47px;
    font-weight: 700;
}

@media (max-width: 768px) {
    .f-subsection-custom {
        .arrow {
            width: 50px;
            right: 10px;
        }
    }
}

@media (max-width: 468px) {
    .btn-connect {
        width: 100%;
        height: 55px;
    }
    .btn-connect-dark {
        width: 100%;
        height: 55px;
        color: #fff !important;
    }
    .form {
        width: 100%;
    }
}

@media (max-width: 600px) {
    .f-subsection-custom {
        display: flex;
        flex-direction: row-reverse;
        justify-content: space-between;
        position: relative;
        margin-bottom: 24px;
        margin-top: 60px;
        .arrow {
            width: 40px;
        }
        .conect-block {
            position: absolute;
            left: 0;
            top: -40px;
            width: 100%;
        }
        h1 {
            font-weight: 400;
            font-size: 42px;
            text-align: left;
            margin: 0;
        }
    }
}
</style>
